
import { DynamicCardComponent } from './dynamic-card/dynamic-card.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { RxReactiveDynamicFormsModule } from '@rxweb/reactive-dynamic-forms';
import { tempDynamicStoreconfig } from './tempDynamicStoreconfig';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsyncUtilityService } from 'src/app/services/async-utility.service';
import { IonicModule } from '@ionic/angular';
import { AppService } from '../services/app.service';
import { PipesModule } from '../pipes/pipes.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { sessionInterceptor } from '../services/session.interceptor';
import { CustomDynamicFormBuilderComponent } from './custom-dynamic-form-builder/custom-dynamic-form-builder.component';
import { RouterModule, Routes } from '@angular/router';
import { CustomTextareaComponent } from './custom-textarea/custom-textarea.component';
import { PreInspectionReportComponent } from './pre-inspection-report/pre-inspection-report.component';
import { TaskchecklistComponent } from './taskchecklist/taskchecklist.component';
import { CustomTablevalComponent } from './custom-tableval/custom-tableval.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CustomTranslateService } from '../services/custom-translate.service';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SelectLanguageComponent } from './select-language/select-language.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { ModelPopupComponent } from './model-popup/model-popup.component';
// import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';

// import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatCardModule } from '@angular/material/card';

import { MatTooltipModule } from '@angular/material/tooltip';
import { PermissionMessageComponent } from './permission-message/permission-message.component';
import { RecordSelectionComponent } from './record-selection/record-selection.component';
import { CustomCameraComponent } from './custom-camera/custom-camera.component';
import { VideoCaptureComponent } from './video-capture/video-capture.component';
import { DeleteMediaComponent } from './delete-media/delete-media.component';
import { ValidationAlertComponent } from './validation-alert/validation-alert.component';
import { LanguageToggleComponent } from './language-toggle/language-toggle.component';
import { MediaUploadProgressComponent } from './media-upload-progress/media-upload-progress.component';
import { ImagePreviewComponent } from './image-preview/image-preview.component';


const routes: Routes = [
  {
    path: 'customeTextArea',
    component: CustomTextareaComponent,
    data: { title: 'Text Area' }
  },
]


@NgModule({
  declarations: [
    DynamicCardComponent,
    CustomDynamicFormBuilderComponent,
    CustomTablevalComponent,
    TaskchecklistComponent,
    CustomTextareaComponent,
    PreInspectionReportComponent,
    SelectLanguageComponent,
    PermissionMessageComponent,
    ModelPopupComponent,
    DeleteMediaComponent,
    RecordSelectionComponent,
    CustomCameraComponent,
    VideoCaptureComponent,
    ValidationAlertComponent,
    LanguageToggleComponent,
    MediaUploadProgressComponent,
    ImagePreviewComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RxReactiveFormsModule,
    // RxReactiveDynamicFormsModule,
    PipesModule,
    RouterModule.forChild(routes),
    FlexLayoutModule,
    MatExpansionModule,
    MatCardModule,
    MatTooltipModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateService
      }, isolate: false, extend: true
    })
  ],
  exports: [
    DynamicCardComponent,
    RxReactiveFormsModule,
    // RxReactiveDynamicFormsModule,
    CustomDynamicFormBuilderComponent,
    CustomTablevalComponent,
    TaskchecklistComponent,
    CustomTextareaComponent,
    PreInspectionReportComponent,
    PermissionMessageComponent,
    FlexLayoutModule,
    MatExpansionModule,
    MatCardModule,
    MatTooltipModule,
    CustomCameraComponent,
    VideoCaptureComponent,
    ValidationAlertComponent,
    LanguageToggleComponent,
    MediaUploadProgressComponent,
    ImagePreviewComponent
  ],
  providers: [
    tempDynamicStoreconfig,
    // AppService,
    AsyncUtilityService,
    { provide: HTTP_INTERCEPTORS, useClass: sessionInterceptor, multi: true }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }